import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, takeUntil } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { EnumStepFunctions } from '../enums/step-functions.enum';
import { IWebSocketParams } from '../interfaces/web-socket-params.interface';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  public wsMessages$: Subject<any>;
  public webSocketConnection$: WebSocketSubject<any>;
  public wsConnection$: Observable<boolean>;
  public disconnected$: Subject<void>;

  constructor() {
    this.wsMessages$ = {} as Subject<any>;
    this.webSocketConnection$ = {} as WebSocketSubject<any>;
    this.wsConnection$ = {} as Observable<any>;
    this.disconnected$ = {} as Subject<any>;
  }

  public wsGetMessages$(type: EnumStepFunctions): Observable<any> {
    return this.wsMessages$ instanceof Subject
      ? this.wsMessages$.pipe(
          filter((data) =>
            Object.keys(data).some((pos) => {
              return pos === type;
            })
          ),
          catchError(this.errorHandler),
          takeUntil(this.disconnected$)
        )
      : throwError('websocket not built');
  }

  public wsSendMessage(message: any): void {
    this.webSocketConnection$.next(message);
  }

  public wsComplete(): void {
    this.webSocketConnection$.complete();
  }

  public errorHandler(error: ErrorEvent): Observable<never> {
    return throwError(error);
  }

  public subscribeWebSocket(): void {
    this.webSocketConnection$
      .pipe(catchError(this.errorHandler), takeUntil(this.disconnected$))
      .subscribe({
        next: (message) => {
          this.wsMessages$.next(message);
        },
        error: (error) => {
          this.wsMessages$.error(error);
        },
        complete: () => {
          this.wsMessages$.complete();
        }
      });
  }

  public webSocketSubject$(params: IWebSocketParams): WebSocketSubject<any> {
    return webSocket({
      url: !params.otherBaseUrlWs
        ? environment.baseUrlWs
        : params.otherBaseUrlWs,
      protocol: [
        'bavv-pasivo-ws-header',
        params.fromObject.authorization,
        params.fromObject.transactionId,
        ...(!params.fromObject.documentNumber
          ? []
          : [params.fromObject.documentNumber])
      ],
      closeObserver: {
        next: () => {
          this.disconnected$.next();
          this.disconnected$.complete();
        }
      }
    });
  }

  public wsBuild(params: IWebSocketParams): void {
    this.wsMessages$ = new Subject<any>();
    this.disconnected$ = new Subject<void>();

    this.webSocketConnection$ = this.webSocketSubject$(params);

    this.subscribeWebSocket();
  }
}
